export default {
  title:
    "Hindi News, Breaking Hindi News, हिंदी न्यूज़, Latest Hindi News, Hindi Samachar, ताजा ख़बरें और अपडेट्स - NewsTak.in",
  description:
    "NewsTak: Get the news in Hindi (हिंदी न्यूज़), breaking news, Today Hindi News, आज के मुख्य समाचार, Crime news, ताजा ख़बरें, हिंदी समाचार, live news on election, current events, politics, entertainment, sports और देश दुनिया से जुड़ी ब्रेकिंग न्यूज़.",
  keywords:
    "Hindi news,ताज़ा ख़बर, ब्रेकिंग न्यूज़, Latest News in Hindi, हिंदी न्यूज़ , Hindi Samachar, हिंदी समाचार, Breaking News in Hindi, Sports News, taza Samachar, Latest Khabar, UP news, MP News, Crime News, Mumbai news, Marathi News, Viral News, live news in Hindi,",
};
